import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["decisionButtons"]
  
  connect() {
    console.log("AML matching controller connected")
    console.log("Token from data attribute:", this.element.dataset.token)
  }
  
  confirmMatch(event) {
    event.preventDefault()
    
    // Show loading indicator
    $('#hotLoader').modal('show')
    
    // Get the AML entity token from data attribute
    const token = this.element.dataset.token
    
    // Make the POST request to handle the decision
    this.postDecision(token, 'match')
  }
  
  rejectMatch(event) {
    event.preventDefault()
    
    // Show loading indicator
    $('#hotLoader').modal('show')
    
    // Get the AML entity token from data attribute
    const token = this.element.dataset.token
    
    // Make the POST request to handle the decision
    this.postDecision(token, 'no_match')
  }
  
  postDecision(token, decision) {
    // Debug log to check if token is being passed correctly
    console.log("Posting decision for token:", token, "Decision:", decision)
    
    // Show clear debug information in the console
    console.group("AML Entity Decision")
    console.log(`Processing ${decision} decision for entity with token: ${token}`)
    
    // Make sure we have a valid token
    if (!token) {
      console.error("No token provided for AML entity!")
      console.groupEnd()
      $('#hotLoader').modal('hide')
      alert("Error: No entity ID found. Please try again.")
      return
    }
    
    fetch(this.element.dataset.actionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html, text/html, application/json'
      },
      body: JSON.stringify({ token: token, decision: decision })
    })
    .then(response => {
      console.log(`Response status: ${response.status}`)
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status}`)
      }
      return response.text()
    })
    .then(html => {
      console.log("Response received:", html ? `${html.length} characters` : "empty")
      
      // Log the first part of the response to see what we're getting
      if (html && html.length > 0) {
        console.log("Response preview:", html.substring(0, 200))
      }
      
      // The response will be a turbo stream that automatically updates the content
      // Check if it's a valid Turbo Stream response
      if (html && html.trim()) {
        // Process any Turbo Stream response
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const streamElements = doc.querySelectorAll('turbo-stream')
        
        console.log(`Found ${streamElements.length} turbo-stream elements`)
        
        if (streamElements.length > 0) {
          // Let Turbo handle the stream updates
          console.log("Rendering turbo stream message")
          Turbo.renderStreamMessage(html)
        } else {
          console.warn("No turbo-stream elements found in response")
        }
      } else {
        console.warn("Empty response received")
        
        // If we got an empty response, try forcing a reload of the current page section
        console.log("Forcing reload of screened_needs_attention view")
        this.forceReloadContent()
      }
      
      console.groupEnd()
      
      // Hide loading indicator
      setTimeout(() => {
        $('#hotLoader').modal('hide')
      }, 500)
    })
    .catch(error => {
      console.error('Error:', error)
      $('#hotLoader').modal('hide')
      // Show error notification
      alert('An error occurred while processing your decision.')
      this.forceReloadContent()
    })
  }
  
  // Force reload the content frame with the next entity
  forceReloadContent() {
    console.log("Force reloading content with next entity")
    
    // Get the frame
    const frame = document.querySelector("#AMLContent")
    
    // Reload the screened_needs_attention view which should show the next entity
    if (frame) {
      // Show loading indicator
      $('#hotLoader').modal('show')
      
      // Path to get the screened entities that need attention
      const url = '/dashboard/aml/turboframe?show=screened_needs_attention'
      
      // Load the frame with the updated content
      frame.setAttribute("src", url)
      
      // Hide loading indicator after frame loads
      frame.addEventListener('turbo:frame-load', function() {
        console.log("Frame loaded with next entity")
        $('#hotLoader').modal('hide')
      }, { once: true })
    }
  }
}